import { createAction } from 'redux-actions';

// Canvas ACTION CREATORS
export const documentLoading = createAction('DOCUMENT_LOADING');
export const getDocument = createAction('GET_DOCUMENT');
export const documentSuccess = createAction('DOCUMENT_SUCCESS');
export const documentError = createAction('DOCUMENT_ERROR');
export const updateDocumentImage = createAction('UPDATE_DOCUMENT_IMAGE');
export const setDocumentLoading  = createAction('SET_DOCUMENT_LOADING');
